import { z } from 'zod';
import { mediaTypeSchema } from '../domain/media-type.js';
import { sortSchema } from '../domain/sort.js';
import { statusSchema } from '../domain/status.js';
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
    }),
});
export const castMemberSchema = z.object({
    id: z.number(),
    name: z.string(),
    character: z.string().nullable(),
    profilePath: z.string().nullable(),
});
export const searchResultSchema = z.object({
    tmdbId: z.number(),
    mediaType: mediaTypeSchema,
    title: z.string(),
    titleOriginal: z.string().nullable(),
    year: z.number().nullable(),
    posterUrl: z.string().nullable(),
    tmdbRating: z.number().nullable(),
});
export const titleDetailsSchema = z.object({
    tmdbId: z.number(),
    mediaType: mediaTypeSchema,
    title: z.string(),
    titleOriginal: z.string().nullable(),
    overview: z.string().nullable(),
    posterUrl: z.string().nullable(),
    backdropUrl: z.string().nullable(),
    releaseDate: z.string().nullable(),
    year: z.number().nullable(),
    genres: z.array(z.string()),
    tmdbRating: z.number().nullable(),
    runtime: z.number().nullable(),
    seasonsCount: z.number().nullable(),
    episodesCount: z.number().nullable(),
    statusText: z.string().nullable(),
    cast: z.array(castMemberSchema),
    status: statusSchema.nullable(),
    rating: z.number().int().min(1).max(10).nullable(),
    folderIds: z.array(z.number()),
    stale: z.boolean().optional(),
});
export const libraryItemSchema = z.object({
    tmdbId: z.number(),
    mediaType: mediaTypeSchema,
    title: z.string(),
    titleOriginal: z.string().nullable(),
    year: z.number().nullable(),
    posterUrl: z.string().nullable(),
    tmdbRating: z.number().nullable(),
    status: statusSchema.nullable(),
    rating: z.number().int().min(1).max(10).nullable(),
    watchedAt: z.string().nullable(),
    updatedAt: z.string(),
});
export const folderSummarySchema = z.object({
    id: z.number(),
    name: z.string(),
    itemCount: z.number(),
    createdAt: z.string(),
});
export const folderItemSchema = libraryItemSchema.extend({
    addedAt: z.string(),
});
export const userSchema = z.object({
    id: z.string(),
    username: z.string().nullable(),
    firstName: z.string().nullable(),
});
export const authResponseSchema = z.object({
    token: z.string(),
    user: userSchema,
});
export const libraryQuerySchema = z.object({
    status: statusSchema.optional(),
    type: mediaTypeSchema.optional(),
    sort: sortSchema.default('added_desc'),
});
export const searchQuerySchema = z.object({
    q: z.string(),
    page: z.coerce.number().int().min(1).default(1),
});
export const setStatusBodySchema = z.object({
    status: statusSchema.nullable(),
});
export const setRatingBodySchema = z.object({
    rating: z.number().int().min(1).max(10).nullable(),
});
export const createFolderBodySchema = z.object({
    name: z.string().min(1).max(100),
});
export const renameFolderBodySchema = z.object({
    name: z.string().min(1).max(100),
});
export const telegramAuthBodySchema = z.object({
    initData: z.string().min(1),
});
//# sourceMappingURL=schemas.js.map